import { render } from "./HomeDecore2.vue?vue&type=template&id=0c429cb1"
import script from "./HomeDecore2.vue?vue&type=script&lang=js"
export * from "./HomeDecore2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__